<template>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
router.push('/')
</script>